import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

import { PanelComponent } from './panel.component';
import { CanDeactivateGuard } from '@app/@core/guards/can-deactivate.guard';

const routes: Routes = [
  { path: '', component: PanelComponent, canDeactivate: [CanDeactivateGuard], data: { title: marker('Panel') } },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PanelRoutingModule {}
